module.exports = __webpack_public_path__ + "images/kuperus14f989d73db69f971889ae12d272f753.png";